import api from "../apiClient";

export function setAuthHeader(accessToken) {
  if (!accessToken) return;
  api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
}

export function clearAuthHeader() {
  delete api.defaults.headers.common["Authorization"];
}

export async function loginRequest({ email, password }) {
  const res = await api.post("/login", { email, password });
  return res.data;
}

export async function registerRequest({ email }) {
  const res = await api.post("/register", { email });
  return res.data;
}

export async function refreshRequest() {
  const res = await api.post("/refresh");
  return res.data;
}

export async function logoutRequest() {
  const res = await api.post("/logout");
  return res.data;
}

export async function meRequest() {
  const res = await api.get("/me");
  return res.data;
}